import { useSelector } from 'react-redux';
import { EmptyState } from 'ui/emptyState';
import { NotificationNoUnreadEmptyState, NotificationNoReadEmptyState } from 'ui/illustrations';
import { notificationCenterSelector } from '../selectors';

const TEXT: { [key: string]: any } = {
  Unread: {
    image: NotificationNoUnreadEmptyState,
    title: 'All caught up!',
    subtitle: 'You have no unread notifications.',
  },
  Read: {
    image: NotificationNoReadEmptyState,
    title: 'No read notifications',
    subtitle: "Notifications you've marked as read will appear here.",
  },
};

export const NotificationEmptyState = () => {
  const {
    filters: { status },
  } = useSelector(notificationCenterSelector);
  const { image, subtitle, title } = TEXT[status];
  return <EmptyState Illustration={image} title={title} subtitle={<span>{subtitle}</span>} />;
};
